import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { CounselTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-counsel-type-container',
  templateUrl: './counsel-type-container.component.html',
  styleUrls: ['./counsel-type-container.component.scss'],
})
export class CounselTypeContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  counseltypes$: Observable<CounselTypeDto[]>;
  loading: boolean;
  isLoadingCounselType$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingCounselType$ = this.gatwayFacade.isLoadingGateway(
      'CounselType'
    );
    this.counseltypes$ = this.gatwayFacade.loadGateway('CounselType');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCounselType(deletedValue: any) {
    this.gatwayFacade.remove('CounselType', deletedValue);
  }

  // this method control both the create and update

  onSubmitCounselType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.CounselTypes;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllCounselType = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllCounselType.push(pullData[i]);
      }
    }

    // check if the addAllCounselType array is not empty, then dispatch the data to the store
    if (addAllCounselType.length > 0) {
      this.gatwayFacade.add('CounselType', addAllCounselType);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('CounselType', allUpdates, ['id']);
    }
  }
}
